import React, { useState, useEffect } from "react";
import { useSelector } from 'react-redux';
import { Row } from "react-bootstrap";
import { Col } from "react-bootstrap";
import DataTable from "react-data-table-component";
import Card from '../UI/Card/Card';
import Button from '../UI/Button/Button';
import InputString from '../UI/Control/InputString';
import FormLibraryTagModal from './FormLibraryTagModal';
import customStyles from '../customStyles';
import NoData from '../NoData';



const FormLibraryTagList = (props) => {
    const EDCUserID = useSelector(state => state.auth.gValue01);
    const [q, setQ] = useState('');
    const [inputVal, setInputVal] = useState('');
    const [rowData, setRows] = useState([]);
    const [userPermission, setUserPermisssion] = useState('RO'); //RO, RW, NA

    const columns = [
        {
            name: "FormID",
            selector: row => row.FormID,
            cellExport: row => row.FormID,
            omit: true
        },
        {
            name: "Form Name",
            selector: row => row.FormName,
            cellExport: row => row.FormName,
            sortable: true,
            center: true,
        },
        {
            name: "Default Tags",
            selector: row => row.DefaultTags,
            cellExport: row => row.DefaultTags,
            sortable: true,
            center: true,
            omit: true
        },
        {
            name: "Tags",
            selector: row => row.Tags,
            cellExport: row => row.Tags,
            sortable: true,
            center: true,
        },
        {
            name: "Creation User",
            selector: row => row.CreationUser,
            cellExport: row => row.CreationUser,
            sortable: true,
            center: true
        },
        {
            name: "Creation Date",
            selector: row => row.CreationDate,
            cellExport: row => row.CreationDate,
            sortable: true,
            center: true,
            sortFunction: (a, b) => { return props.sortByDateTime(a.CreationDate, b.CreationDate); }
        },
        {
            name: "Action",
            button: true,
            className: 'headercaption',
            width: '14%',
            style: {
                'border-right-style': 'solid',
                'border-width': '1px',
                'border-color': 'rgba(0, 0, 0, 0.12)',
                'justify-content': 'center'
            }
            , cell: (row) => (
                <div style={{ "padding": "5px" }}>
                    <FormLibraryTagModal action="edit" btn="true" disabled={false} text={"Add/Edit"} header={row.FormName + " - Add/Edit Tag(s)"} tag={row.Tag} formId={row.FormID} defaultTags={row.DefaultTags}
                        tags={row.Tags} fetchEDCFormsLibTag={fetchEDCFormsLibTag} />
                    <Button id="btnDelete" variant="primary" className="btn btn-danger" style={{ "margin": "5px" }} onClick={() => DeleteFormLibraryTags(row, event)}>Delete</Button>
                </div>
            )
        }
    ];

    const filteredColumns = ['FormName', 'DefaultTags','Tags', 'CreationUser', 'CreationDate'];
    function search(rows) {

        let selString = q.toString();
        let searchText = selString.toLowerCase().split(",");
        return rows.filter((row) => {
            return filteredColumns.some((column) => {
                if (searchText.length > 1)
                    return searchText.indexOf(row[column].toString().toLowerCase()) > -1;
                else
                    return row[column].toString().toLowerCase().indexOf(q.toLowerCase()) > -1;
            });
        });
    }

    const searchChangeHandler = (e) => {
        setQ(e.target.value);
        setInputVal(e.target.value);
    };

    const fetchEDCFormsLibTag = async () => {
        const response = await fetch('api/ServiceCall/GetEDCFormLibTag')
        if (!response.ok) {
            throw new Error("Something went wrong, message :" + response.message + " \nHttp Error:" + response.httpError)
        }
        const edcForms = await response.text();
        let listForms = JSON.parse(edcForms);
        const arrEDCForms = new Array();
        for (var iCount = 0; iCount < listForms.length; iCount++) {
            arrEDCForms.push({ FormName: listForms[iCount].FormName, FormID: listForms[iCount].FormID })
        }
        setRows(listForms);
    }


    useEffect(() => {
        fetchEDCFormsLibTag();
        getUserRole();
    }, []);

    const getUserRole = () => {
        fetch('api/Users/GetRoleByID?userID=' + EDCUserID)
            .then(response => response.text())
            .then(role => {
                setCompPermission(role);
            });
    };

    const setCompPermission = (usrRole) => {
        if (usrRole == "Read-Only")
            setUserPermisssion("RO");
        else if (usrRole == "Database Designer")
            setUserPermisssion("RW");
        else if (usrRole == "Tester")
            setUserPermisssion("RW");
        else if (usrRole == "Database Administrator")
            setUserPermisssion("RW");
        else if (usrRole == "Management, Image Services" || usrRole == "Image Services Coordinator")
            setUserPermisssion("RO");
        else if (usrRole == "Clinical Data Manager" || usrRole == "Manager, Clinical Data Management")
            setUserPermisssion("RW");
        else
            setUserPermisssion("NA");
    };

    const DeleteFormLibraryTags = (row, event) => {
        var con = confirm('Are you sure, you want to remove tag(s) from the form "' + row.FormName + '"?');
        if (con == true) {
            let model =
            {
                FormID: row.FormID
            }

            fetch('api/ServiceCall/DeleteFormLibraryTags', {
                method: 'POST',
                headers: { 'Content-type': 'application/json' },
                body: JSON.stringify(model)
            }).then(r => r.text()).then(res => {
                let retVal = res.replace(/["']/g, "");
                if (retVal == "1") {
                    fetchEDCFormsLibTag();
                }
                else {
                    alert('Tags are not saved, Something went wrong.');
                    return false;
                }
            })

            return true;
        }
    };

    return <Card>
        <Row style={{ marginBottom: "10px" }}>
            <Col md={6}>
                <div className="input-group">
                    <InputString id="txtSearch" value={inputVal} onChangeHandler={searchChangeHandler} placeholder="Search" />
                </div>
            </Col>
            <Col md={4} />
            <Col md={2}>
            </Col>
        </Row>
        <div className="tableContainer" style={{ width: "50%" }}>
            {search(rowData).length > 0 ? <DataTable
                columns={columns}
                data={search(rowData)}
                className="table table-striped table-bordered table-hover"
                customStyles={customStyles}
                sortFunction={props.sortFunctionByTable}
                striped
                pagination
                paginationPerPage={50}
                paginationRowsPerPageOptions={[20, 50, 100]}
            /> : <NoData headers={columns}></NoData>}
        </div>
    </Card>
}

export default FormLibraryTagList;